import useSWRMutation from "swr/mutation";
import {
  ForgotPasswordRequest,
  ResendConfirmEmailRequest,
  ResetPasswordRequest,
  SignUpUser,
} from "@/services/api/auth/types";

export const useForgotPassword = () => {
  return useSWRMutation("/api/auth/forgot", async (url, { arg }: { arg: ForgotPasswordRequest }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(arg),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to request password reset");
    }

    return response.json();
  });
};

export const useResendConfirmEmail = () => {
  return useSWRMutation("/api/auth/confirm/resend", async (url, { arg }: { arg: ResendConfirmEmailRequest }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arg),
    });

    if (!response.ok) {
      throw response;
    }

    return response.json();
  });
};

export const useResetPassword = () => {
  return useSWRMutation("/api/auth/reset", async (url, { arg }: { arg: ResetPasswordRequest }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(arg),
    });

    if (!response.ok) {
      throw response;
    }

    return response.json();
  });
};

// New hook for login
export const useLogin = () => {
  return useSWRMutation("/api/auth/login", async (url, { arg }: { arg: { email: string; password: string } }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arg),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Login failed");
    }
    return response.json();
  });
};

// New hook for logout
export const useLogout = () => {
  return useSWRMutation("/api/auth/logout", async url => {
    const response = await fetch(url, {
      method: "POST",
    });
    if (!response.ok) {
      throw new Error("Error logging out");
    }
    return response.json();
  });
};

// New hook for registering a parent user
export const useRegisterParent = () => {
  return useSWRMutation("/api/auth/register/parent", async (url, { arg }: { arg: { data: SignUpUser } }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(arg.data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Parent registration failed");
    }
    return response.json();
  });
};

// New hook for registering a vendor user
export const useRegisterVendor = () => {
  return useSWRMutation("/api/auth/register/vendor", async (url, { arg }: { arg: { data: SignUpUser } }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(arg.data),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Vendor registration failed");
    }
    return response.json();
  });
};
